







































import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';

import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Pagination from '@/components/Pagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';

import api from '@/libs/api';
import format from '@/libs/numberFormat';
import { PartnershipList, PartnershipListResponse } from '@/libs/api.interfaces';

interface ReportParams {
  page: number;
  export: boolean;
  name: string | undefined;
}

@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Pagination,
    ActionPopup,
  },
  methods: {
    format,
  },
})
export default class PartnershipTable extends Vue {
  loading = true;
  partnershipList: PartnershipList[] = [];

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;
  merchantCode = '';

  format!: (val: string) => string;

  // eslint-disable-next-line class-methods-use-this
  openDetail(id: number) {
    window.open(`/auto-disbursement-management/partnership-list/${id}`, '_blank');
  }

  @Watch('page')
  onPageChange() {
    this.$router.push({
      query: { ...this.$route.query, page: this.page.toString() },
    });
  }

  async getPartnership(params: ReportParams) {
    try {
      const { data } = await api.get<PartnershipListResponse>('/disbursement/partner', {
        params: {
          page: params.page,
          export: params.export ? true : undefined,
          // eslint-disable-next-line @typescript-eslint/camelcase
          merchant_name: params.name,
        },
      });

      if (params.export) {
        this.loading = false;
        return data as unknown as string;
      }

      const totalBalance = data.data.map((item: PartnershipList) => item.balance).reduce((b, c) => b + c);
      this.$emit('updateTotalBalance', totalBalance);

      this.page = params.page;
      this.partnershipList = data.data;
      this.totalPage = Math.ceil(data.total / data.per_page);
      this.from = data.from;
      this.to = data.to;
      this.totalItem = data.total;
      this.loading = false;

      this.$emit('updateLoading', false);

      return null;
    } catch (err) {
      this.loading = false;
      console.error(err);

      throw err;
    }
  }
}
